
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/email-archive",
      function () {
        return require("private-next-pages/email-archive.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/email-archive"])
      });
    }
  